export default __webpack_public_path__ + "static/media/white-star.cf610978.svg";